export async function callGemini(
  input: string, 
  apiKey: string, 
  systemPrompt?: string, 
  signal?: AbortSignal, 
  modelOverride?: string,
  history: { role: 'user' | 'ai' | 'system'; content: string }[] = [],
  silent: boolean = false
): Promise<string> {
  try {
    const model = modelOverride || 'gemini-2.0-flash-lite';
    
    // Map history to Gemini's format
    const contents = [];
    
    // 1. System Prompt (as a user message since Gemini 1.5/2.0 handle instructions best at the start)
    if (systemPrompt) {
      contents.push({ role: 'user', parts: [{ text: `System Instruction: ${systemPrompt}` }] });
      contents.push({ role: 'model', parts: [{ text: "Understood. I will act as OS Bot with those instructions." }] });
    }
    
    // 2. Conversation History
    for (const msg of history) {
      const role = msg.role === 'ai' ? 'model' : 'user';
      const text = msg.role === 'system' ? `[System Log]: ${msg.content}` : msg.content;
      contents.push({ role, parts: [{ text }] });
    }
    
    // 3. Current Input
    contents.push({ role: 'user', parts: [{ text: input }] });

    const res = await fetch(
      `https://generativelanguage.googleapis.com/v1beta/models/${model}:generateContent?key=${apiKey}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal,
        body: JSON.stringify({ contents })
      }
    );
    
    if (!res.ok) {
      const errorBody = await res.text();
      if (!silent) {
        console.error(`[Gemini Provider] HTTP Error ${res.status}:`, errorBody);
      }
      if (res.status === 429) {
        throw new Error('Gemini Quota Exhausted (429). Please wait or switch providers.');
      }
      throw new Error(`Gemini API Error: ${res.status}`);
    }

    const data = await res.json();
    return data.candidates?.[0]?.content?.parts?.[0]?.text || '';
  } catch (error: any) {
    if (!silent) {
      console.error('[Gemini Provider] Fetch Error:', error);
    }
    throw error;
  }
}
